<template>
  <div class="category">
    <a-modal
      v-model:visible="visible"
      :zIndex="10090"
      :title="`${mode == 'add' ? '新增' : '修改'}${moduleName}`"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form
        :rules="rules"
        layout="vertical"
        class="small"
        ref="blockForm"
        :model="formState"
      >
        <a-form-item :label="`${moduleName}名称：`" name="name">
          <a-input v-model:value="formState.name" placeholder="请输入" />
        </a-form-item>
        <!-- <a-form-item :label="`${moduleName}地址：`" name="url" v-if="!isChild">
          <a-input v-model:value="formState.url" placeholder="请输入" />
        </a-form-item> -->
      </a-form>
    </a-modal>
  </div>
</template>
<script setup>
import { defineExpose, defineProps, ref, reactive, defineEmits } from 'vue'
import useAPI from 'UseApi'
const {
  category_addOrUpdate_post_,
  category_delete_post_,
  category_list_post_
} = useAPI(null, [8992])
import { Form } from 'ant-design-vue'
const useForm = Form.useForm

defineProps({
  mode: {
    type: String,
    default: 'add'
  },
  categoryId: {
    type: String,
    default: ''
  }
})
const rules = ref({
  name: [{ required: true, message: 'Please input page name!' }]
})

const ruleModule = {
  name: [{ required: true, message: 'Please input module name!' }]
}
let initFormState = {
  name: ''
}
const formState = reactive(initFormState)

const blockForm = ref(null)
const visible = ref(false)
const isChild = ref(false)
const moduleName = ref('')

const { resetFields, validate } = useForm(formState, rules, {})

const open = item => {
  Object.assign(formState, item)
  isChild.value = !!item.childModule
  isChild.value && (rules.value = ruleModule)
  moduleName.value = isChild.value ? '模块' : '页面'
  typeof formState.parentId === 'number' && delete formState.parentId
  typeof formState.id === 'number' && delete formState.id
  switch (item.opera) {
    case 'add':
      delete formState.name
      if (item.childModule) {
        formState.parentId = item.id
      }
      visible.value = !visible.value
      break
    case 'update':
      formState.id = item.id
      visible.value = !visible.value
      break
    case 'del':
      break
  }
  console.log(formState)
}

const handleOk = async () => {
  await validate()
  switch (formState.opera) {
    case 'add':
      await addOrUpdateCategory()
      break
    case 'update':
      await addOrUpdateCategory()
      break
    case 'del':
      await addOrUpdateCategory()
      break
  }
  emit('getCategory')
  visible.value = false
  cancel()
}
const addOrUpdateCategory = async () => {
  await category_addOrUpdate_post_(formState)
}

const getCategory = async () => {
  await category_list_post_(formState)
}

const deleteCategory = async () => {
  await category_delete_post_(formState)
}

console.log(deleteCategory, getCategory)

const cancel = () => {
  resetFields()
}

const emit = defineEmits(['getCategory'])
defineExpose({ open })
</script>
